 <template>
	 <div class="row">

	 	<div class="col text-center" v-for="step in this.dataTree" :key="step.id">

	 	    <b-card header-tag="header" size="sm" class="mt-3 mb-3 step">
					<template #header>
					<h6 class="mt-1 mb-0 float-left pt-1">{{step.content.nicename}}</h6><b-button v-if="step.type!=='trigger'" @click="triggerDelete(step.id)" class="float-right" size="sm" variant="danger"><i class="fa fa-trash"></i></b-button>
					</template>
					<b-card-text>
					
					<template v-if="step.type=='trigger'">
						<template v-if="step.content.trigger=='popup-form-fill' && step.content.popup">When contact fills in popup: 
						{{   defaults.popups.filter(obj => { return obj.value === step.content.popup })[0].text  }}</template>
					</template>

					<template v-if="step.type=='wait'">
						<template v-if="step.content.type=='period' && step.content.period_value && step.content.period_units">{{ step.content.period_value }} {{ defaults.delay.period_units.filter(obj => { return obj.value === step.content.period_units })[0].text }}</template>
					</template>

					<template v-if="step.type=='deck'">
						<template v-if="step.content.deck">{{  defaults.template_decks.filter(obj => { return obj.value === step.content.deck })[0].text }}</template>
					</template>	
					<template v-if="step.type=='sms'">
						<template v-if="step.content.sms">{{ step.content.sms }}</template>
					</template>	
					<template v-if="step.type=='logic'">
						<template v-if="step.content.logic">
							<template v-if="step.content.logic == 'deck-open'">
								If deck '{{  defaults.template_decks.filter(obj => { return obj.value === step.content.deck })[0].text }}' has been viewed.
							</template>
						</template>
					</template>						

					</b-card-text>
					<b-button @click="triggerEdit(step.id)" variant="primary"><i class="fa fa-edit"></i></b-button>
					

			</b-card>

			<!-- <b-button class="triggerAdd d-block" @click="triggerAdd(step.id)"><i class="fa fa-plus"></i></b-button> -->


			<div v-if="step.type=='logic'" class="add-step-wrap">
				<div class="step-connect-left">
					<template v-show="step.content.else_next_step">
						<div class="logic-label-if">If</div>
					</template>
				</div>
				<b-button v-show="!step.content.if_next_step" :class="['add-step-left rounded-circle','else-not-set-'+!step.content.else_next_step]" variant="outline-light" size="sm" :id="'popover-target-left-'+step.id">
				    If <i class="fa fa-plus"></i>
				</b-button>
				<b-popover :target="'popover-target-left-'+step.id" triggers="focus" placement="top">
				    <b-button @click="triggerAdd(step.id,'wait','if')">Wait</b-button>
				    <b-button @click="triggerAdd(step.id,'deck','if')">Deck</b-button>
				    <b-button @click="triggerAdd(step.id,'sms','if')">SMS</b-button>
				    <b-button @click="triggerAdd(step.id,'logic','if')">Logic</b-button>
				</b-popover>
				
				<div class="step-connect-right">
					<template v-show="step.content.else_next_step">
						<div class="logic-label-else">Else</div>
					</template>
				</div>
				<b-button v-show="!step.content.else_next_step" :class="['add-step-right rounded-circle','if-not-set-'+!step.content.if_next_step]" variant="outline-light" size="sm" :id="'popover-target-right-'+step.id">
				    Else <i class="fa fa-plus"></i>
				</b-button>
				<b-popover :target="'popover-target-right-'+step.id" triggers="focus" placement="top">
				    <b-button @click="triggerAdd(step.id,'wait','else')">Wait</b-button>
				    <b-button @click="triggerAdd(step.id,'deck','else')">Deck</b-button>
				    <b-button @click="triggerAdd(step.id,'sms','else')">SMS</b-button>
				    <b-button @click="triggerAdd(step.id,'logic','else')">Logic</b-button>
				</b-popover>
				
			</div>
			<div v-else class="add-step-wrap">
				<div class="step-connect"></div>
				<b-button class="add-step rounded-circle" variant="outline-light" size="sm" :id="'popover-target-'+step.id">
				    <i class="fa fa-plus"></i>
				</b-button>
				<b-popover :target="'popover-target-'+step.id" triggers="focus" placement="top">
				    <b-button @click="triggerAdd(step.id,'wait')">Wait</b-button>
				    <b-button @click="triggerAdd(step.id,'deck')">Deck</b-button>
				    <b-button @click="triggerAdd(step.id,'sms')">SMS</b-button>
				    <b-button @click="triggerAdd(step.id,'logic')">Logic</b-button>
				</b-popover>
			</div>



			  
			<automation-step-tree :class="[step.type=='logic'?'logic':'not-logic','if-not-set-'+!step.content.if_next_step,'else-not-set-'+!step.content.else_next_step]" v-if="step.childNodes.length > 0" :dataTree="step.childNodes" @triggerAdd="emitTriggerAdd" @triggerEdit="triggerEdit" @triggerDelete="triggerDelete" :defaults="defaults"></automation-step-tree>

	  	</div>

	</div>
</template>
<script>
    export default {
        name: "automation-step-tree",
        props: ["dataTree","defaults"],
        methods:{
        	emitTriggerAdd: function(args){
        		var parent_id = args.parent_id;
				var type = args.type;
				var logic = args.logic;
				this.$emit('triggerAdd',{'parent_id':parent_id,'type':type,'logic':logic})},
        	triggerAdd: function(parent_id,type,logic=false){
        		this.$emit('triggerAdd',{'parent_id':parent_id,'type':type,'logic':logic})
        	},
        	triggerEdit: function(id){this.$emit('triggerEdit',id)},
        	triggerDelete: function(id){this.$emit('triggerDelete',id)},
        }
    }
</script>